module.exports = __webpack_public_path__ + "assets/img/statistics.bd4551c4.png";